const PROD_TURNSTILE_SITE_KEY = '0x4AAAAAADsvVI83LzNbfnaf'
const UAT_TURNSTILE_SITE_KEY = '0x4AAAAAADpgsxWN7P1wjht8'
const TURNSTILE_TOKEN_GENERATION_TIMEOUT_MS = 13000
const MANAGED_TURNSTILE_TOKEN_GENERATION_TIMEOUT_MS = 20000
const MANAGED_TURNSTILE_CONFIG = {
  mode: 'managed',
  size: 'normal',
  appearance: 'interaction-only',
  execution: 'execute',
  timeoutMs: MANAGED_TURNSTILE_TOKEN_GENERATION_TIMEOUT_MS,
} as const
const INVISIBLE_TURNSTILE_CONFIG = {
  mode: 'invisible',
  size: 'invisible',
  execution: 'execute',
  timeoutMs: TURNSTILE_TOKEN_GENERATION_TIMEOUT_MS,
} as const

export const turnstileConfig = {
  prod: {
    enabled: true,
    enabledProducts: ['car'],
    siteKey: PROD_TURNSTILE_SITE_KEY,
    ...MANAGED_TURNSTILE_CONFIG,
  },
  master: {
    enabled: true,
    enabledProducts: ['car'],
    siteKey: UAT_TURNSTILE_SITE_KEY,
    ...MANAGED_TURNSTILE_CONFIG,
  },
  dev: {
    enabled: true,
    enabledProducts: ['car'],
    siteKey: UAT_TURNSTILE_SITE_KEY,
    ...MANAGED_TURNSTILE_CONFIG,
  },
  local: {
    enabled: false,
    enabledProducts: [],
    siteKey: '',
    ...INVISIBLE_TURNSTILE_CONFIG,
  },
}
